export const TypesAutorizarEntrada = {
    CONSULTARGATE: "CONSULTARGATE",
    RESETAUTORIZARENTRADA: "RESETAUTORIZARENTRADA",
}

const INITIAL = {
    gateId: 0,
}

export default function autorizarEntradaReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesAutorizarEntrada.CONSULTARGATE:
            return {
                ...state,
                gateId: action.payload.gateId
            };
        case TypesAutorizarEntrada.RESETAUTORIZARENTRADA:
            return INITIAL;
        default:
            return state;
    }
}

export const AutorizarEntradaActions = {
    consultarGate,
    resetStateAutorizarEntrada,
}

function consultarGate(pgateId) {

    return {
        type: TypesAutorizarEntrada.CONSULTARGATE,
        payload: { gateId: pgateId }
    }
}

function resetStateAutorizarEntrada() {
    return { type: "RESETAUTORIZARENTRADA" }
}